<template>
  <v-container no-gutters class="pa-0">
    <v-row no-gutters :class="{highlight: highlight}" align="center" >
      <v-col cols="auto">
        <v-icon left :large="large" v-if="platformCode">{{getPlatformIcon(platformCode)}}</v-icon>
      </v-col>
      <v-col>
        <slot>
          <v-container class="pa-0">
            <v-row no-gutters>
              <v-col class="ma-0 pa-0 pr-2" cols="auto">
                <pre class="online-id">{{onlineId}}</pre>
              </v-col>
              <v-col v-if="gameCode" cols="12" sm="6" class="ma-0 pa-0">
                <span class="gameName">{{getGameName(gameCode)}}</span>
              </v-col>
            </v-row>
          </v-container>
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import platformMixins from "@/mixins/platformMixins"
import gameMixin from "@/mixins/gameMixin"

export default {
  name: "UserOnlineId",
  mixins: [platformMixins, gameMixin],
  props: {
    platformCode: {
      type: String,
      required: false
    },
    onlineId: {
      type: String,
      required: true
    },
    gameCode: {
      type: String,
      required: false
    },
    large: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style scoped>
.highlight,
.highlight i
 {
  color: var(--v-primary-base);
}
.online-id {
  display:inline;
  word-break:break-all;
  white-space:normal;
}
.gameName {
  color: var(--v-secondary-base);
}
</style>